import * as React from "react";
import {Header, Modal} from "semantic-ui-react";
import AceEditor from "react-ace";
import {AIAgentTask} from "../../../../../generated/api";
import 'brace/mode/groovy'
import 'brace/ext/searchbox'

export interface AiAgentTaskRawModalProps {
    isOpen: boolean
    onClose: () => void
    aiAgentTask: AIAgentTask
}

export function AiAgentTaskRawModal(props: AiAgentTaskRawModalProps) {

    return <Modal
        id='AiAgentTaskRawModal'
        open={props.isOpen}
        onClose={props.onClose}
        size='fullscreen'
        closeIcon
    >
        <Header icon='list' content='AiAgentTask Raw'/>
        <Modal.Content>
            <AceEditor
                mode="json"
                theme="monokai"
                name="UNIQUE_ID_OF_DIV"
                editorProps={{$blockScrolling: true}}
                value={JSON.stringify(props.aiAgentTask, null, 4)}
                readOnly={true}
                width="100%"
                height="800px"
            />
        </Modal.Content>
    </Modal>
}